import { Typography, Stack, Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import { withDefaults } from '../../utils/withDefaults';
import { spreadTypography } from '../../utils/typeUtils';
export const Header = styled('div')(() => ({
  display: 'flex',
  width: '100%'
}));
const ContentRoot = styled(Stack)(({
  theme
}) => ({
  '&:has(div)': {
    marginTop: theme.spacing(1),
    borderTop: `1px solid ${theme.palette.grey[300]}`,
    paddingTop: theme.spacing(1)
  }
}));
export const Footer = styled(Box)(({
  theme
}) => ({
  display: 'flex',
  justifyContent: 'space-between',
  marginTop: theme.spacing(1),
  borderTop: `1px solid ${theme.palette.grey[300]}`,
  paddingTop: theme.spacing(1)
}));
export const Avatar = styled('div')(({
  theme
}) => ({
  display: 'flex',
  flex: '0 0 auto',
  paddingRight: theme.spacing(1)
}));
export const HeaderContent = styled('div')(() => ({
  flex: '1 1 auto'
}));
export const RightCorner = styled('div')(() => ({
  flex: '0 0 auto',
  alignSelf: 'flex-start'
}));
export const Title = styled(Typography)(({
  theme,
  size
}) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  color: theme.palette.grey[800],
  ...(size === 'large' && {
    ...spreadTypography(theme.typography['Lato H5 Bold'])
  }),
  ...(size === 'medium' && {
    ...spreadTypography(theme.typography['Lato Emphasized 1'])
  }),
  ...(size === 'small' && {
    ...spreadTypography(theme.typography['Lato Emphasized 2'])
  })
}));
export const SubTitle = styled(Typography)(({
  theme,
  size
}) => ({
  ...spreadTypography(theme.typography[size === 'small' ? 'Lato Body 2' : 'Lato Body 1']),
  color: theme.palette.grey[600]
}));
export const Text = styled(Typography)(({
  theme,
  size
}) => ({
  ...spreadTypography(theme.typography[size === 'small' ? 'Lato Body 2' : 'Lato Body 1']),
  paddingTop: theme.spacing(1),
  color: theme.palette.grey[800]
}));
export const Description = styled(Text)({
  display: 'flex',
  flexWrap: 'wrap'
});
export const Content = withDefaults(ContentRoot, {
  direction: 'row',
  alignItems: 'center',
  justifyContent: 'space-between'
});